import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 76.385 87.283',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="snowflake-regular"
      className="icon"
      d="M75.029,60.553l-6.683-3.921,5.813-1.585a2.727,2.727,0,0,0,1.892-3.341l-.7-2.642a2.68,2.68,0,0,0-3.29-1.926l-13.587,3.7-12.24-7.194,12.257-7.194,13.587,3.7a2.688,2.688,0,0,0,3.29-1.926l.7-2.642a2.74,2.74,0,0,0-1.892-3.341l-5.813-1.585,6.683-3.921A2.772,2.772,0,0,0,76.035,23l-1.347-2.37a2.657,2.657,0,0,0-3.665-1.006L64.34,23.543l1.551-5.916A2.74,2.74,0,0,0,64,14.286l-2.591-.7a2.688,2.688,0,0,0-3.29,1.926L54.487,29.322,42.23,36.516V22.111L52.168,12a2.769,2.769,0,0,0,0-3.853L50.276,6.222a2.655,2.655,0,0,0-3.785,0l-4.245,4.33V2.728A2.7,2.7,0,0,0,39.57,0H36.894a2.7,2.7,0,0,0-2.676,2.728v7.859l-4.245-4.33a2.655,2.655,0,0,0-3.785,0l-1.96,1.926a2.769,2.769,0,0,0,0,3.853l9.939,10.109V36.55L21.909,29.356,18.278,15.547a2.68,2.68,0,0,0-3.29-1.926l-2.591.7A2.727,2.727,0,0,0,10.5,17.661l1.551,5.916L5.373,19.656a2.661,2.661,0,0,0-3.665,1.006L.361,23.031a2.761,2.761,0,0,0,.989,3.733l6.683,3.921L2.219,32.237A2.727,2.727,0,0,0,.327,35.578l.7,2.642a2.68,2.68,0,0,0,3.29,1.926l13.587-3.7L30.16,43.642,17.9,50.836l-13.587-3.7a2.688,2.688,0,0,0-3.29,1.926l-.7,2.642a2.74,2.74,0,0,0,1.892,3.341l5.813,1.585L1.35,60.553a2.772,2.772,0,0,0-.989,3.733l1.347,2.37a2.657,2.657,0,0,0,3.665,1.006l6.683-3.921L10.5,69.656A2.74,2.74,0,0,0,12.4,73l2.591.7a2.688,2.688,0,0,0,3.29-1.926l3.631-13.809,12.257-7.194V65.173L24.227,75.282a2.769,2.769,0,0,0,0,3.853l1.892,1.926a2.655,2.655,0,0,0,3.785,0l4.245-4.33v7.825a2.7,2.7,0,0,0,2.676,2.728H39.5a2.7,2.7,0,0,0,2.676-2.728V76.7l4.245,4.33a2.655,2.655,0,0,0,3.785,0L52.1,79.1a2.769,2.769,0,0,0,0-3.853L42.161,65.139V50.734l12.257,7.194L58.05,71.736a2.68,2.68,0,0,0,3.29,1.926l2.591-.7a2.727,2.727,0,0,0,1.892-3.341l-1.551-5.916,6.683,3.921a2.661,2.661,0,0,0,3.665-1.006l1.347-2.37a2.665,2.665,0,0,0-.938-3.7Z"
      transform="translate(-0.003)"
      fill={fill}
    />
  </svg>
);

export default SVG;
